import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

const IconCompleteNew = props => (
  <SvgIcon {...props}>
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={14} cy={14} r={14} fill="#FFBE00" />
      <path
        d="m11.863 16.585-2.78-2.78-.946.94 3.726 3.726 8-8-.94-.94-7.06 7.054Z"
        fill="#000"
        opacity={0.7}
      />
    </svg>
  </SvgIcon>
)

export default IconCompleteNew
